const styles = `:host{font:var(--goto-body-small);width:100%;box-sizing:border-box!important}`;export default styles;